import { CSSProperties } from "react";

export const XMeapleSvg = ({
  width,
  color = "#ECE800",
  style,
}: {
  width: number;
  color?: string;
  style?: CSSProperties;
}) => {
  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 150 150"
      style={{
        filter:
          "drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.25)) drop-shadow(4px 4px 4px rgba(0, 0, 0, 0.21))",
        ...style,
      }}
    >
      <path
        d="M62.0068 150L75.1121 119.159V0C60.1346 2.47192e-06 48.9013 19.6262 50.7735 37.3832C13.7976 45.7944 -2.11592 58.4112 0.224283 67.2897C2.60655 76.3278 18.6342 81.4642 27.8392 82.7103C27.8392 97.1963 8.64915 119.159 4.90482 131.308V150H62.0068Z"
        fill={color}
      />
      <path
        d="M87.9932 150L74.8879 119.159V0C89.8654 2.47192e-06 101.099 19.6262 99.2265 37.3832C136.202 45.7944 152.116 58.4112 149.776 67.2897C147.393 76.3278 131.366 81.4642 122.161 82.7103C122.161 97.1963 141.351 119.159 145.095 131.308V150H87.9932Z"
        fill={color}
      />
    </svg>
  );
};
